export default function gcode ({
  bullet,
  name,
  noseType,
  faceDoc,
  roughDoc,
  finishDoc1,
  finishDoc2,
  roughFeedrate,
  faceFeedrate,
  finishFeedrate1,
  finishFeedrate2,
  cutoffFeedrate,
  stockDiameter,
  offset,
  cutoffToolWidth,
  cutoffOffsetX,
  cutoffOffsetZ,
  junctureRadius,
  backlash
}) {
  if (!bullet) return
  let output = ''
  let {
    length,
    meplat,
    diameter,
    noseLength,
    bearingSurfaceLength,
    boattailLength,
    baseDiameter,
    radiusInches,
    drivingBandDiameter,
    rtr,
    hybridRadius,
    hybrid,
    centerX,
    centerY
  } = bullet
  if (drivingBandDiameter > 0) {
    drivingBandDiameter += .0003
    diameter -= .0003
  }
  if (noseType !== 'secant' && noseType !== 'haack') meplat = 0
  const toolRadius = .015

  if (!diameter || !roughDoc || !faceDoc || !finishDoc1 || !finishDoc2 || !stockDiameter || !roughFeedrate || !finishFeedrate1 || !finishFeedrate2 || !offset) return ''

  let bearingSurfaceBacklashAdjustment = (backlash / ((diameter + drivingBandDiameter - baseDiameter) / 2)) * boattailLength

  let n = 0
  function g (strings) {
    let code = ''
    for (let i = 1; i < arguments.length; ++i) {
      code += strings[i - 1]
      if (arguments[i] && arguments[i].toFixed) {
        code += arguments[i].toFixed(4)
      } else {
        code += arguments[i]
      }
    }
    for (let i = arguments.length - 1; i < strings.length; ++i) {
      code += strings[i]
    }
    output += `${code}\n`
  }

  g`%`
  if (name) {
    g`(${name})`
  }
  g`(bullet length: ${length})`
  g`(nose length: ${noseLength})`
  g`(bearing surface length: ${bearingSurfaceLength})`
  g`(boattail length: ${boattailLength})`
  g`(base diameter: ${baseDiameter})`
  g`(diameter: ${diameter})`
  g`(nose type: ${noseType})`
  if (noseType === 'secant') {
    g`(nose radius: ${radiusInches})`
    g`(rt/r: ${rtr})`
  }
  if (noseType === 'secant' || noseType === 'haack') {
    g`(meplat: ${meplat})`
  }
  g``
  g`G7 (diameter mode)`
  g`G18 (xz plane)`
  g`G20 (inch mode)`
  g`G90 (absolute distance mode)`
  g`G40 (cancel radius compensation)`
  //g`G10 L1 P1 R.01 I3 J20 Q6`
  g`T1 M6 (tool 1)`
  //g`g42.1 D.01 L6 (tool radius compensation)`

  g``
  g`(face)`
  g`F${faceFeedrate}`
  g`G41`
  g`G0 Z${length + faceDoc + cutoffOffsetZ + cutoffToolWidth + offset}`
  g`G0 X${stockDiameter + offset}`
  g`G0 Z${length}`
  g`G1 X${-toolRadius}`
  g`G0 Z${length + offset}`

  g``
  g`(rough nose)`
  g`F${roughFeedrate}`
  const nosePasses = Math.ceil((stockDiameter - meplat) / roughDoc)
  for (let i = nosePasses; i >= 0; --i) {
    if (finishDoc1 + finishDoc2 + meplat + i * roughDoc < stockDiameter) {
      g`G40`
      g`G0 Z${length + offset}`
      g`G0 X0`
      g`G42`
      g`G0 X${meplat + i * roughDoc + finishDoc1 + finishDoc2} Z${length}`
      nosePath(i * roughDoc + finishDoc1 + finishDoc2 + drivingBandDiameter, .01)
    }
  }

  g``
  g`(rough body)`
  g`G40`
  g`F${roughFeedrate}`
  g`G1 X${stockDiameter}`
  g`G0 X${stockDiameter + offset}`
  const bearingSurfacePasses = Math.ceil((stockDiameter - diameter) / roughDoc)
  for (let i = bearingSurfacePasses; i >= 0; --i) {
    const x = diameter + finishDoc1 + finishDoc2 + i * roughDoc + drivingBandDiameter
    if (x < stockDiameter) {
      g`G0 Z${length - noseLength + offset}`
      g`G1 X${x - backlash}`
      g`G1 X${x - backlash} Z${-cutoffToolWidth}`
      g`G1 X${stockDiameter}`
      g`G0 X${stockDiameter + offset}`
    }
  }

  [ finishDoc2, 0 ].forEach((finishOffset, i) => {
    g``
    g`(finish pass ${(i + 1).toString()})`
    g`F${finishOffset ? finishFeedrate1 : finishFeedrate2}`
    if (finishOffset === 0) {
      g`G4 P10`
    }
    g`G40`
    g`G0 X${stockDiameter + offset}`
    g`G0 Z${length + toolRadius * 2}`
    g`G0 X${-offset}`
    g`(finish nose)`
    g`G42`
    g`G1 Z${length} X${meplat + finishOffset}`
    nosePath(finishOffset, .0005)
    g`(finish body)`
    if (drivingBandDiameter === 0) {
      //g`G1 X${diameter + finishOffset} Z${boattailLength + bearingSurfaceBacklashAdjustment}`
      g`G1 X${diameter + finishOffset} Z${-cutoffToolWidth}`
    } else {
      let angle = 1.5
      let slopeLength = drivingBandDiameter / Math.atan(angle * Math.PI / 180)
      let flatLength = (bearingSurfaceLength - slopeLength) / 2
      if (flatLength < .1) {
        angle = 30
        slopeLength = drivingBandDiameter / Math.atan(angle * Math.PI / 180)
        flatLength = (bearingSurfaceLength - slopeLength) / 2
      }
      g`G1 X${diameter + finishOffset} Z${boattailLength + slopeLength + flatLength}`
      g`(driving band transition = ${angle.toFixed(1)}deg)`
      g`(flat length = ${flatLength}")`
      g`(transition length = ${slopeLength}")`
      g`G1 X${diameter + drivingBandDiameter + finishOffset} Z${boattailLength + flatLength}`
      g`G1 X${diameter + drivingBandDiameter + finishOffset} Z${-cutoffToolWidth}`
    }
    g`G1 X${stockDiameter}`
  })

  g``
  g`(rough boattail)`
  g`F${roughFeedrate}`
  g`G40`
  const boattailPasses = Math.ceil((diameter - baseDiameter) / roughDoc)
  for (let i = boattailPasses; i >= 0; --i) {
    const boattailDelta = ((diameter + drivingBandDiameter - baseDiameter) / boattailLength) * (toolRadius + bearingSurfaceBacklashAdjustment)
    const x1 = diameter + finishDoc1 + finishDoc2 + i * roughDoc + drivingBandDiameter
    const x2 = baseDiameter + finishDoc1 + finishDoc2 + i * roughDoc + drivingBandDiameter
    const x3 = x2 - boattailDelta
    if (x2 <= diameter + finishDoc1 + finishDoc2 + drivingBandDiameter) {
      g`G0 X${diameter + offset} Z${boattailLength + bearingSurfaceBacklashAdjustment}`
      g`G1 X${x1} Z${boattailLength + bearingSurfaceBacklashAdjustment}`
      g`G1 X${x2} Z${bearingSurfaceBacklashAdjustment}`
      g`G1 X${x3} Z${-toolRadius}`
      g`G1 X${x3} Z${-cutoffToolWidth}`
      g`G1 X${stockDiameter + offset}`
    }
  }

  [ finishDoc2, 0 ].forEach((finishOffset, i) => {
    g``
    g`(finish boattail)`
    g`F${finishOffset ? finishFeedrate1 : finishFeedrate2}`

    if (junctureRadius > 0) {
      const boattailDelta = ((diameter + drivingBandDiameter - baseDiameter) / boattailLength) * toolRadius
      const boattailAngleRadians = Math.atan2((diameter - baseDiameter) / 2, boattailLength)
      const m1 = Math.tan((boattailAngleRadians / 2) - Math.PI / 2)
      const radiusZAdjust = junctureRadius * Math.sqrt(1 / (1 + m1 * m1))
      const a = Math.sin(boattailAngleRadians) * radiusZAdjust
      const b = Math.cos(boattailAngleRadians) * radiusZAdjust
      g`G40`
      g`G0 X${diameter + finishOffset + offset} Z${boattailLength + radiusZAdjust + offset}`
      g`G0 X${diameter + finishOffset} Z${boattailLength + radiusZAdjust + toolRadius * 2}`
      g`G42`
      g`G0 X${diameter + finishOffset - backlash} Z${boattailLength + radiusZAdjust}`
      g`G3 X${diameter + finishOffset - a * 2 - backlash} Z${boattailLength - b} R${junctureRadius}`
      g`G1 X${baseDiameter + finishOffset - backlash} Z${0}`
      g`G1 X${baseDiameter + finishOffset - backlash} Z${0}`
      g`G1 X${baseDiameter - boattailDelta + finishOffset - backlash} Z${-toolRadius}`
      g`G1 X${baseDiameter - boattailDelta + finishOffset - backlash} Z${-cutoffToolWidth}`
      g`G1 X${stockDiameter}`
    } else {
      const boattailDelta = ((diameter + drivingBandDiameter - baseDiameter) / boattailLength) * (toolRadius + bearingSurfaceBacklashAdjustment)
      g`G40`
      g`G0 X${diameter + boattailDelta + finishOffset} Z${boattailLength + bearingSurfaceBacklashAdjustment + cutoffToolWidth}`
      g`G1 X${diameter + drivingBandDiameter + finishOffset} Z${boattailLength + bearingSurfaceBacklashAdjustment}`
      g`G1 X${diameter + drivingBandDiameter + finishOffset} Z${boattailLength + bearingSurfaceBacklashAdjustment}`
      g`G1 X${baseDiameter + finishOffset} Z${bearingSurfaceBacklashAdjustment}`
      g`G1 X${baseDiameter - boattailDelta + finishOffset} Z${-toolRadius}`
      g`G1 X${baseDiameter - boattailDelta + finishOffset} Z${-cutoffToolWidth}`
      g`G1 X${stockDiameter}`
    }
    g``
  })


  g`(cutoff)`
  g`G40`
  g`F${cutoffFeedrate}`
  g`G0 Z${-cutoffOffsetZ}`
  g`G0 X${cutoffOffsetX - stockDiameter - offset}`
  g`G1 X${cutoffOffsetX}`
  g``
  g`(home)`
  g`G0 X${cutoffOffsetX - stockDiameter / 4} Z${length + faceDoc - cutoffOffsetZ + cutoffToolWidth + toolRadius * 2}`
  g`%`

  function nosePath (offset, inc) {
    if (noseType === 'haack' || noseType === 'power' || noseType === 'ellipse') {
      let step = inc
      let hx2 = 0
      if (hybridRadius > 0 && rtr > 0 && hybrid) {
        hx2 = hybrid.x2
      }
      for (let i = 0; i < noseLength - hx2; i += step) {
        const d = diameter
        const l = noseLength
        const hz = i
        let hx
        if (noseType === 'haack') {
          hx = ((d - meplat) / 4) * Math.sqrt(((4 * Math.PI) - (4 * Math.acos((-l + 2 * hz) / l)) + (2 * Math.sin(2 * Math.acos((-l + 2 * hz) / l)))) / Math.PI) + meplat / 2
        } else if (noseType === 'power') {
          hx = (Math.pow(i, .75) / Math.pow(noseLength, .75)) * (diameter / 2)
        } else if (noseType === 'ellipse') {
          hx  = (diameter / 2) * Math.sqrt(1 - (Math.pow(noseLength - i, 2) / Math.pow(noseLength, 2)))
        }
        g`G1 Z${length - i} X${((hx * 2) || 0) + offset}`
        if (hx * 2 + offset > stockDiameter) return
        step += inc
      }
      if (hybridRadius > 0 && rtr > 0 && hybrid) {
        g`G3 X${diameter + offset} Z${boattailLength + bearingSurfaceLength + hybrid.x1} R${hybridRadius}`
      } else {
        g`G1 Z${length - noseLength} X${diameter + offset}`
      }
    } else { // noseType === 'secant'
      if (diameter + offset > stockDiameter) {
        // (z - h)^2 + (x - k)^2 = r^2
        const h = centerX - noseLength
        const k = -centerY - offset / 2
        const x = -stockDiameter / 2
        const z = Math.sqrt(Math.pow(radiusInches, 2) - Math.pow(x - k, 2)) + h
        g`G3 X${stockDiameter} Z${length + z} R${radiusInches}`
      } else {
        if (hybridRadius > 0 && rtr > 0) {
          g`G3 X${hybrid.y2 * 2 + offset} Z${boattailLength + bearingSurfaceLength + hybrid.x2} R${radiusInches}`
          g`G3 X${diameter + offset} Z${boattailLength + bearingSurfaceLength + hybrid.x1} R${hybridRadius}`
        } else {
          g`G3 X${diameter + offset} Z${boattailLength + bearingSurfaceLength} R${radiusInches}`
        }
      }
    }
  }

  const minutes = estimateTime(output)
  output = output.replace('%', `%\n(${minutes.toFixed(2)} minutes estimated time)`)
  return output
}

function estimateTime (output) {
  const lines = output.split('\n')
  const dists = {}
  const pos = {
    x: 0,
    z: parseFloat(lines[lines.length - 2].split('Z')[1])
  }
  let f = 0..toFixed(2)
  lines.forEach(line => {
    if (line.includes('F')) {
      const parts = line.split(' ')
      parts.forEach(part => {
        if (part[0] === 'F') {
          f = parseFloat(part.replace('F', '')).toFixed(2)
        }
      })
    }
    if (line.includes('X') || line.includes('Z')) {
      const parts = line.split(' ')
      let X = pos.x
      let Z = pos.z
      parts.forEach(part => {
        if (part[0] === 'X') {
          X = parseFloat(part.replace('X', ''))
        }
        if (part[0] === 'Z') {
          Z = parseFloat(part.replace('Z', ''))
        }
      })
      const d = dist(pos, { x: X, z: Z })
      pos.x = X
      pos.z = Z
      let tf = line.includes('G0') ? '32' : f
      if (!dists[tf]) dists[tf] = 0
      dists[tf] += d
    }
  })
  let minutes = 0
  for (const fr in dists) {
    const dist = dists[fr]
    minutes += dist / fr
  }
  return minutes
}

function dist(p1, p2) {
  return Math.sqrt(
    Math.pow(p2.x - p1.x, 2) +
    Math.pow(p2.z - p1.z, 2)
  )
}
